import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n/I18nContext";
import { formatPrice } from "@/utils/price";
import api from "@/lib/api";
import { DASHBOARD } from "@/constants/testIds";

const STATUS_VARIANT = {
  completed: "default", failed: "destructive", refunded: "secondary",
  pending_payment: "outline", paid: "secondary",
};

export default function OrdersTab() {
  const { t, language } = useI18n();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get("/orders").then(({ data }) => setOrders(data));
  }, []);

  if (orders.length === 0) {
    return (
      <div className="rounded-2xl border border-dashed border-border p-12 text-center">
        <p className="text-muted-foreground">{t("dashboard.noOrders")}</p>
        <Button asChild className="mt-4 rounded-full">
          <Link to="/create">{t("dashboard.createFirstSong")}</Link>
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {orders.map((o) => (
        <Link
          to={o.status === "pending_payment" ? `/checkout/${o.order_id}` : `/orders/${o.order_id}`}
          key={o.order_id}
          data-testid={DASHBOARD.orderRow(o.order_id)}
          className="flex items-center justify-between rounded-2xl border border-border bg-card p-5 transition-colors hover:border-primary/40"
        >
          <div>
            <p className="font-medium">{o.generated?.title || t(`options.style_${o.form.style}`)}</p>
            <p className="text-xs text-muted-foreground">{new Date(o.created_at).toLocaleDateString()}</p>
          </div>
          <div className="flex items-center gap-3">
            <span className="font-heading text-sm font-semibold">{formatPrice(o.pricing.total, language)}</span>
            <Badge variant={STATUS_VARIANT[o.status] || "outline"} className="rounded-full">
              {t(`order.status${o.status.charAt(0).toUpperCase()}${o.status.slice(1).replace(/_([a-z])/g, (_, c) => c.toUpperCase())}`)}
            </Badge>
          </div>
        </Link>
      ))}
    </div>
  );
}
